module.exports = __webpack_public_path__ + "static/media/edit_icon_white.9b1748c7.svg";